/** Deterministic display helpers for sample catalog cards and license text. */

export const CATALOG_LICENSE_INFO_URL = 'https://creativecommons.org/share-your-work/cclicenses/';
export const CREATIVE_COMMONS_LICENSES_URL = 'https://creativecommons.org/licenses/';

function hashStringToNonNegativeInt(s) {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (Math.imul(31, h) + s.charCodeAt(i)) | 0;
  }
  return h >>> 0;
}

/** Tailwind gradient classes for catalog card headers (deterministic per dataset id). */
export const CATALOG_THUMB_PALETTES = [
  'bg-gradient-to-br from-cyan-300 via-sky-500 to-indigo-700 dark:from-slate-950 dark:via-sky-950 dark:to-indigo-950',
  'bg-gradient-to-br from-amber-300 via-orange-500 to-rose-700 dark:from-stone-950 dark:via-orange-950 dark:to-rose-950',
  'bg-gradient-to-br from-violet-300 via-fuchsia-500 to-pink-700 dark:from-violet-950 dark:via-fuchsia-950 dark:to-pink-950',
  'bg-gradient-to-br from-lime-300 via-emerald-500 to-teal-800 dark:from-lime-950 dark:via-emerald-950 dark:to-teal-950',
  'bg-gradient-to-br from-sky-300 via-blue-500 to-indigo-800 dark:from-sky-950 dark:via-blue-950 dark:to-indigo-950',
  'bg-gradient-to-br from-rose-300 via-red-500 to-orange-800 dark:from-rose-950 dark:via-red-950 dark:to-orange-950'
];

/**
 * @param {string} seed — usually sample id
 * @returns {{ paletteClass: string, patternAngle: number, hueRotate: number, scale: number }}
 */
export function getCatalogThumbVariant(seed) {
  const h = hashStringToNonNegativeInt(seed || 'catalog');
  return {
    paletteClass: CATALOG_THUMB_PALETTES[h % CATALOG_THUMB_PALETTES.length],
    patternAngle: h % 180,
    hueRotate: (h % 56) - 28,
    scale: 1 + ((h >> 6) % 14) / 100
  };
}

/**
 * @param {string | null | undefined} license
 * @returns {{ href: string, label: string } | null}
 */
export function getLicenseLink(license) {
  if (!license || typeof license !== 'string') return null;
  const s = license.trim();
  if (/CC\s*BY-NC-SA/i.test(s)) {
    return { href: 'https://creativecommons.org/licenses/by-nc-sa/4.0/', label: 'CC BY-NC-SA 4.0' };
  }
  if (/CC\s*BY-NC/i.test(s)) {
    return { href: 'https://creativecommons.org/licenses/by-nc/4.0/', label: 'CC BY-NC 4.0' };
  }
  if (/CC\s*BY/i.test(s)) {
    return { href: 'https://creativecommons.org/licenses/by/4.0/', label: 'CC BY 4.0' };
  }
  if (/public\s*domain/i.test(s)) {
    return {
      href: 'https://creativecommons.org/publicdomain/zero/1.0/',
      label: 'Public Domain (CC0)'
    };
  }
  return null;
}

/** Short hostname (or truncated URL) for source links on catalog cards. */
export function formatSourceLinkLabel(url) {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return url.length > 48 ? `${url.slice(0, 45)}…` : url;
  }
}
